import { Stack } from 'expo-router';
import { FullHeightWrapper } from '~/layout/components/full-height-wrapper/FullHeightWrapper';
import { OverviewHeader } from '~/calendar/components/overview-header/OverviewHeader';

export default function Layout() {
  return (
    <FullHeightWrapper>
      <OverviewHeader />
      <Stack screenOptions={{ headerShown: false, animation: 'none' }}>
        <Stack.Screen name="index" />
        <Stack.Screen name="[overviewDate]" />
      </Stack>
    </FullHeightWrapper>
  );
}
